import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import classNames from 'classnames';
import {
  MarkerTypesSelector,
  NewMarkerModal,
  ConfirmationPrompt
} from 'components';

import {getMarkerTypes} from 'api';
import * as Actions from 'actions';

class MarkerOptionsSettings extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show_marker_key : '',
      currently_hovered_marker : '',
      editing_marker_key : '',
      marker_name : '',
      show_delete_marker_modal : false,
      deleting_marker_key : ''
    }

    this.handleClickMarker = this.handleClickMarker.bind(this)
    this.renderMarkerTypes = this.renderMarkerTypes.bind(this)
    this.markerButtonsClassName = this.markerButtonsClassName.bind(this)
    this.editMarkerName = this.editMarkerName.bind(this)
    this.handlePencilClick = this.handlePencilClick.bind(this)
    this.handleSelectMarker = this.handleSelectMarker.bind(this)
    this.handleDeleteMarker = this.handleDeleteMarker.bind(this)
  }

  handleClickMarker(key) {
    this.state.show_marker_key === '' ?
    this.setState({show_marker_key : key}) :
    this.setState({show_marker_key : ''})
  }

  markerButtonsClassName(key) {
    return (
      classNames (
        'col-md-2 col-xs-2',
        {
          hide : this.state.currently_hovered_marker !== key,
          'animated fadeIn' : this.state.currently_hovered_marker === key
        }
      )
    )
  }

  editMarkerName() {
    if(this.state.marker_name == '') {
      this.props.notify({ message: 'Marker types must have a name' });
    }
    else {
      this.props.sendSocketEmit({key : this.state.editing_marker_key, name : this.state.marker_name}, 'update-marker-name')
      this.setState({marker_name : '', editing_marker_key : ''})
    }
  }

  handlePencilClick(key, name) {
    if(this.state.editing_marker_key === key) {
      this.setState({
        editing_marker_key : '',
        marker_name : ''
      })
    }
    else {
      this.setState({
        editing_marker_key : key,
        marker_name : name
      })
    }
  }

  handleSelectMarker(new_key, current_key) {
    this.props.sendSocketEmit({old_key : current_key, new_key}, 'set-marker')
  }

  handleDeleteMarker() {
    this.props.sendSocketEmit({key : this.state.deleting_marker_key}, 'unset-marker')
    this.setState({show_delete_marker_modal : false})
  }

  renderMarkerTypes() {
    let {marker_types} = this.props.canvassing;
    let _self = this;

    return (
      marker_types.map((mt, idx) => {
        return (
          <div
            key={mt.key}
            className='map-markers-settings-marker-container'
            onMouseEnter={() => {setTimeout(this.setState({currently_hovered_marker : mt.key}), 20)}}
            onMouseLeave={() => {this.setState({currently_hovered_marker : ''})}}
            >
            <div className='row' style={{marginBottom : this.state.show_marker_key === mt.key ? '10px' : '0px'}}>
              <div className='col-md-2 col-xs-2 map-markers-settings-marker markers-image-wrapper'>
                <img
                  style={{height: '30px'}}
                  src={`assets/images/${mt.url}`}
                  onClick={() => {this.handleClickMarker(mt.key)}}
                  className='marker-settings-marker-image'
                />
              </div>
              {(() => {
                if(this.state.editing_marker_key === mt.key) {
                  return (
                    <div className='col-md-8 col-xs-8'>
                      <input
                        className='form-control'
                        value={this.state.marker_name}
                        onChange={(e) => {this.setState({marker_name : e.target.value})}}
                        onKeyDown={({key}) => {key === 'Enter' ? this.editMarkerName() : null}}
                      />
                    </div>
                  )
                }
                else {
                  return (
                    <div className='col-md-8 col-xs-8'>
                      {mt.name}
                    </div>
                  )
                }
              })()}
              <div className={this.markerButtonsClassName(mt.key)}>
                <div>
                  <i
                    className='fa fa-pencil'
                    onClick={() => {this.handlePencilClick(mt.key, mt.name)}}
                  />
                </div>
                <div>
                  <i
                    className='fa fa-trash'
                    onClick={() => {this.setState({
                      show_delete_marker_modal : true,
                      deleting_marker_key : mt.key
                     })}}
                  />
                </div>
              </div>
            </div>
            <Panel
              collapsible
              expanded={_self.state.show_marker_key === mt.key}
              style={{marginBottom : _self.state.show_marker_key === mt.key ? '15px' : '0px'}}
              >
              <MarkerTypesSelector
                marker_types={this.props.marker_types}
                handleSelectMarker={this.handleSelectMarker}
                current_marker_key={mt.key}
              />
            </Panel>
          </div>
        )
      })
    )
  }

  render() {
    return (
      <div className='marker-options-settings animated fadeIn'>
        <NewMarkerModal marker_types={this.props.marker_types}/>
        <ConfirmationPrompt
          handleCancelPrompt={() => {this.setState({show_delete_marker_modal : false})}}
          handleConfirmPrompt={this.handleDeleteMarker}
          type='warning'
          show_condition={this.state.show_delete_marker_modal}
          title='Delete Marker?'
          body='Are you sure you want to delete this marker?'
          confirm_button_text='Delete'
          cancel_button_text='Cancel'
          bsSize='small'
        />
        {this.renderMarkerTypes()}
        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <div className='add-new-marker-button'>
              <div
                className='btn btn-block btn-dark'
                onClick={() => {this.props.toggleShowCreateNewMarkerModal(true)}}
                >
                <h6><span><i className='fa fa-plus' /></span>{'   '}Create Marker Type</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

let mapStateToProps = ({canvassing}) => ({canvassing})

export default connect(mapStateToProps, Actions)(MarkerOptionsSettings)



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/marker-options-settings.js